// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__TKD1W","logo":"Loading_logo__2yOXb","spinner":"Loading_spinner__LcDI3","spin":"Loading_spin__OlMP1"};